import SDPHelpers from './sdp_helpers';

const { RECVONLY, INACTIVE } = SDPHelpers.MediaDirection;

const changeMediaDirection = async (peerConnection, direction) => {
  if (!peerConnection) return;

  const transceivers = peerConnection.getTransceivers();
  let canChangeTransceiversDirection = transceivers.some(transceiver => transceiver.direction);

  if (canChangeTransceiversDirection) {
    const currentDirection = direction === RECVONLY ? INACTIVE : RECVONLY;
    transceivers.filter(transceiver =>
      transceiver.sender?.track?.kind === 'video'
      && transceiver.currentDirection === currentDirection
      && transceiver.direction !== direction
    ).forEach((transceiver) => {
      try {
        // eslint-disable-next-line no-param-reassign
        transceiver.direction = direction;
      } catch (e) {
        canChangeTransceiversDirection = false;
      }
    });
  }

  if (!canChangeTransceiversDirection) {
    const offer = await peerConnection.createOffer();
    await peerConnection.setLocalDescription(offer);
    const { sdp } = peerConnection.remoteDescription;
    peerConnection.setRemoteDescription({
      type: peerConnection.remoteDescription.type,
      // replaces the 'a=recvonly' lines to 'a=inactive' or viceversa, depending on active.
      sdp: SDPHelpers.changeMediaDirection(sdp, direction),
    });
  }
};

/**
 * Changes the RTP media direction
 * @param {Object} peerConnection - the peer connection to apply the change
 * @param {('recvonly' | 'inactive')} direction - The new direction that could be recvonly or
 * inactive. If it's inactive, then the peer connection will stop sending RTP media.
 */
export default {
  changeMediaDirectionToInactive: peerConnection => changeMediaDirection(
    peerConnection, INACTIVE),
  changeMediaDirectionToRecvOnly: peerConnection => changeMediaDirection(
    peerConnection, RECVONLY),
};
